import dayjs from 'dayjs'

/**
 * 日期时间工具 —— 逐一对应旧 common.js 的同名方法，保证迁移后展示格式零差异。
 */

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n)
}

/** 旧 timeStamp2String：时间戳 -> YYYY-MM-DD HH:mm:ss */
export function timeStamp2String(time?: number | string | null): string {
  if (time == null || time === '') return ''
  const d = new Date(Number(time))
  if (Number.isNaN(d.getTime())) return ''
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(
    d.getMinutes()
  )}:${pad2(d.getSeconds())}`
}

/** 旧 timeStamp3String：时间戳 -> 同上（旧工程两个函数实现完全一致，保留别名以降低迁移心智成本） */
export const timeStamp3String = timeStamp2String

/** 旧 dateStamp2String：日期串 -> 截取日期部分 */
export function dateStamp2String(time?: string | null): string {
  if (time == null || time === '') return ''
  return String(time).substring(0, 10)
}

/** 旧 getNowFormatDate：今天 YYYY-MM-DD */
export function getNowFormatDate(): string {
  return dayjs().format('YYYY-MM-DD')
}

/** 旧 getCurrentMonthFirst：本月第一天 YYYY-MM-DD */
export function getCurrentMonthFirst(): string {
  return dayjs().startOf('month').format('YYYY-MM-DD')
}

/**
 * 旧 getLastMongthFormatDate：一个月前 YYYY-MM-DD。
 * 注意：旧实现用 date.getMonth()（0 基）拼接，等价于「当前月 -1」，此处一致。
 */
export function getLastMongthFormatDate(): string {
  return dayjs().subtract(1, 'month').format('YYYY-MM-DD')
}

/** 旧 getNowYearFormatDate：当前年份 YYYY */
export function getNowYearFormatDate(): string {
  return dayjs().format('YYYY')
}

/** 旧 getFormatAddDate(n)：当前日期加 n 天，YYYY-MM-DD */
export function getFormatAddDate(n: number): string {
  return dayjs().add(n, 'day').format('YYYY-MM-DD')
}

/** 旧 getLogDateTime(dateTime)：'YYYY-MM-DD...' -> 'YYYY-MM' */
export function getLogDateTime(dateTime: string): string {
  return String(dateTime).substring(0, 7)
}

/* --------------------------- 常用组合区间 --------------------------- */

/** 最近 7 天区间，返回 [start, end] */
export function last7Days(): [string, string] {
  return [dayjs().subtract(6, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}

/** 最近 30 天区间 */
export function last30Days(): [string, string] {
  return [dayjs().subtract(29, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}

/** 本月区间 */
export function currentMonthRange(): [string, string] {
  return [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}

/** 通用格式化 */
export function formatDate(v: any, fmt = 'YYYY-MM-DD'): string {
  if (v == null || v === '') return ''
  const d = dayjs(v)
  return d.isValid() ? d.format(fmt) : ''
}

export { dayjs }
